// extracted by mini-css-extract-plugin
export var bubble = "_3s-0";
export var container = "_3s-3";
export var contrastBorder = "_3s-4";
export var greyOut = "_3s-2";
export var initialsWrapper = "_3s-1";
export var large = "_3s-9";
export var medium = "_3s-8";
export var mediumSmall = "_3s-7";
export var mediumSmallMedium = "_3s-c";
export var micro = "_3s-5";
export var small = "_3s-6";
export var tiny = "_3s-b";
export var xTiny = "_3s-a";